import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers, Teleport as _Teleport, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3d24bb9b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "helpdesk-page" }
const _hoisted_2 = { class: "helpdesk-heading" }
const _hoisted_3 = { class: "helpdesk-heading-actions" }
const _hoisted_4 = {
  key: 0,
  class: "helpdesk-avatar-manager"
}
const _hoisted_5 = {
  class: "helpdesk-avatar-preview",
  "aria-hidden": "true"
}
const _hoisted_6 = ["src"]
const _hoisted_7 = { key: 1 }
const _hoisted_8 = ["disabled"]
const _hoisted_9 = ["disabled"]
const _hoisted_10 = ["disabled"]
const _hoisted_11 = ["disabled"]
const _hoisted_12 = ["aria-label"]
const _hoisted_13 = ["placeholder", "onKeydown"]
const _hoisted_14 = { value: "" }
const _hoisted_15 = ["value"]
const _hoisted_16 = { value: "" }
const _hoisted_17 = ["value"]
const _hoisted_18 = { value: "" }
const _hoisted_19 = ["value"]
const _hoisted_20 = {
  key: 1,
  class: "helpdesk-alert",
  role: "alert"
}
const _hoisted_21 = ["aria-label"]
const _hoisted_22 = { class: "helpdesk-list-scroll" }
const _hoisted_23 = ["aria-expanded", "onClick"]
const _hoisted_24 = { class: "helpdesk-ticket-group-meta" }
const _hoisted_25 = { class: "helpdesk-ticket-count" }
const _hoisted_26 = {
  key: 0,
  class: "helpdesk-ticket-group-content"
}
const _hoisted_27 = {
  key: 0,
  class: "helpdesk-group-empty"
}
const _hoisted_28 = {
  key: 1,
  class: "helpdesk-group-empty"
}
const _hoisted_29 = ["onClick"]
const _hoisted_30 = { class: "helpdesk-ticket-top" }
const _hoisted_31 = { class: "helpdesk-ticket-subject" }
const _hoisted_32 = {
  key: 0,
  class: "helpdesk-ticket-requester"
}
const _hoisted_33 = { class: "helpdesk-ticket-meta" }
const _hoisted_34 = {
  key: 3,
  class: "helpdesk-pagination"
}
const _hoisted_35 = ["disabled", "onClick"]
const _hoisted_36 = ["disabled", "onClick"]
const _hoisted_37 = ["aria-busy"]
const _hoisted_38 = {
  key: 0,
  class: "helpdesk-empty"
}
const _hoisted_39 = {
  key: 1,
  class: "helpdesk-empty"
}
const _hoisted_40 = { class: "helpdesk-detail-summary" }
const _hoisted_41 = { class: "helpdesk-detail-head" }
const _hoisted_42 = { class: "helpdesk-detail-number" }
const _hoisted_43 = { class: "helpdesk-facts" }
const _hoisted_44 = { key: 0 }
const _hoisted_45 = { key: 1 }
const _hoisted_46 = {
  key: 0,
  class: "helpdesk-auto-close"
}
const _hoisted_47 = {
  key: 1,
  class: "helpdesk-management"
}
const _hoisted_48 = ["disabled"]
const _hoisted_49 = ["value"]
const _hoisted_50 = ["disabled"]
const _hoisted_51 = ["value"]
const _hoisted_52 = ["disabled"]
const _hoisted_53 = { class: "helpdesk-attachment-list" }
const _hoisted_54 = ["disabled", "onClick"]
const _hoisted_55 = ["onClick"]
const _hoisted_56 = ["aria-label"]
const _hoisted_57 = { class: "helpdesk-message-head" }
const _hoisted_58 = ["disabled", "onClick"]
const _hoisted_59 = ["onClick"]
const _hoisted_60 = ["onSubmit"]
const _hoisted_61 = { class: "helpdesk-reply-editor" }
const _hoisted_62 = ["placeholder", "disabled"]
const _hoisted_63 = {
  key: 0,
  class: "helpdesk-reply-files"
}
const _hoisted_64 = ["disabled", "onClick"]
const _hoisted_65 = {
  key: 1,
  class: "helpdesk-reply-waiting"
}
const _hoisted_66 = ["disabled"]
const _hoisted_67 = { class: "helpdesk-reply-actions" }
const _hoisted_68 = ["disabled"]
const _hoisted_69 = ["disabled"]
const _hoisted_70 = ["disabled"]
const _hoisted_71 = ["onClick"]
const _hoisted_72 = ["aria-label"]
const _hoisted_73 = ["aria-label"]
const _hoisted_74 = { class: "helpdesk-preview-content" }
const _hoisted_75 = ["src", "alt"]

import { computed, nextTick, onBeforeUnmount, onMounted, ref, watch } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "vuex";
import { getLocale } from "@/i18n";
import { formatDateTime } from "@/utils/date";
import HelpdeskDataService from "@/services/helpdesk/HelpdeskDataService";
import {
  ASSISTANT_AVATAR_UPDATED_EVENT,
  HELPDESK_REALTIME_CONNECTED_EVENT,
  HELPDESK_REALTIME_EVENT,
  HelpdeskRealtimeEvent,
} from "@/services/helpdesk/HelpdeskRealtime";
import { AuthGetters } from "@/store/modules/auth";
import {
  HelpdeskAttachment,
  HelpdeskMessage,
  HelpdeskTicketDetails,
  HelpdeskTicketSummary,
  TicketCategory,
  TicketPriority,
  TicketStatus,
} from "@/types/helpdesk/Helpdesk";

type TicketGroupKey = "active" | "resolved" | "closed";
interface TicketGroupState {
  key: TicketGroupKey;
  statuses: TicketStatus[];
  expanded: boolean;
  items: HelpdeskTicketSummary[];
  page: number;
  totalElements: number;
  totalPages: number;
  loading: boolean;
  itemsLoaded: boolean;
  requestId: number;
}

interface PendingRealtimeUpdate {
  event: HelpdeskRealtimeEvent;
  statuses: Set<TicketStatus>;
  refreshSelected: boolean;
  refreshGroups: boolean;
}

interface RealtimeApplyResult {
  refreshSelected: boolean;
  messageAdded: boolean;
  attachmentAdded: boolean;
}


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const copies = {
  ru: {
    title: "Helpdesk",
    managerSubtitle: "Обращения пользователей и работа службы поддержки",
    userSubtitle: "Ваши обращения в службу поддержки",
    refresh: "Обновить",
    filters: "Фильтры обращений",
    search: "Номер, тема или пользователь",
    allStatuses: "Все статусы",
    allCategories: "Все категории",
    allPriorities: "Все приоритеты",
    find: "Поиск",
    tickets: "Обращения",
    activeTickets: "Активные обращения",
    resolvedTickets: "Решённые обращения",
    closedTickets: "Закрытые обращения",
    loading: "Загрузка обращений...",
    emptyGroup: "В этой группе обращений нет",
    previous: "Назад",
    next: "Далее",
    backToTickets: "К обращениям",
    loadingTicket: "Загрузка обращения...",
    selectTicket: "Выберите обращение слева",
    requester: "Пользователь",
    assignee: "Ответственный",
    notAssigned: "Не назначен",
    priority: "Приоритет",
    section: "Раздел",
    errorCode: "Код ошибки",
    status: "Статус",
    waitingForUserStatus: "Ожидается ответ пользователя",
    autoCloseAt: "Автоматическое закрытие:",
    assignToMe: "Назначить на меня",
    attachments: "Вложения",
    dialog: "Переписка по обращению",
    newMessages: "Новые сообщения",
    replyPlaceholder: "Напишите ответ...",
    addImages: "Добавить изображения",
    replyAttachmentsHint: "JPEG или PNG, до 5 файлов. Скриншот можно вставить через Ctrl+V.",
    waitingForUser: "Ожидать ответ пользователя",
    waitingForUserHint: "Включите, если для продолжения нужен ответ пользователя. Если ответа не будет в течение 3 дней, обращение закроется автоматически.",
    remove: "Удалить",
    send: "Отправить",
    sending: "Отправка...",
    loadError: "Не удалось загрузить обращения.",
    actionError: "Не удалось выполнить действие. Обновите данные и повторите попытку.",
    replyFileError: "Можно прикрепить до 5 изображений JPEG или PNG размером не более 10 МБ.",
    replyPartialUpload: "Ответ отправлен, но часть изображений не загрузилась.",
    downloadError: "Не удалось скачать вложение.",
    previewError: "Не удалось открыть вложение.",
    preview: "Предпросмотр вложения",
    download: "Скачать",
    close: "Закрыть",
    uploadAvatar: "Загрузить аватар Аяна",
    changeAvatar: "Изменить аватар Аяна",
    deleteAvatar: "Удалить",
    deleteAvatarConfirm: "Удалить текущий аватар Аяна?",
    avatarFileError: "Для аватара можно использовать JPEG или PNG размером до 10 МБ.",
    avatarActionError: "Не удалось обновить аватар Аяна.",
  },
  en: {
    title: "Helpdesk",
    managerSubtitle: "User requests and support operations",
    userSubtitle: "Your support requests",
    refresh: "Refresh",
    filters: "Ticket filters",
    search: "Number, subject, or user",
    allStatuses: "All statuses",
    allCategories: "All categories",
    allPriorities: "All priorities",
    find: "Search",
    tickets: "Tickets",
    activeTickets: "Active tickets",
    resolvedTickets: "Resolved tickets",
    closedTickets: "Closed tickets",
    loading: "Loading tickets...",
    emptyGroup: "No tickets in this group",
    previous: "Previous",
    next: "Next",
    backToTickets: "Back to tickets",
    loadingTicket: "Loading ticket...",
    selectTicket: "Select a ticket on the left",
    requester: "Requester",
    assignee: "Assignee",
    notAssigned: "Not assigned",
    priority: "Priority",
    section: "Section",
    errorCode: "Error code",
    status: "Status",
    waitingForUserStatus: "Waiting for user reply",
    autoCloseAt: "Automatic closing:",
    assignToMe: "Assign to me",
    attachments: "Attachments",
    dialog: "Ticket conversation",
    newMessages: "New messages",
    replyPlaceholder: "Write a reply...",
    addImages: "Add images",
    replyAttachmentsHint: "JPEG or PNG, up to 5 files. You can paste a screenshot with Ctrl+V.",
    waitingForUser: "Wait for the user's reply",
    waitingForUserHint: "Enable this when the user's reply is required to continue. If there is no reply within 3 days, the ticket will close automatically.",
    remove: "Remove",
    send: "Send",
    sending: "Sending...",
    loadError: "Could not load tickets.",
    actionError: "Could not complete the action. Refresh the data and try again.",
    replyFileError: "Attach up to 5 JPEG or PNG images no larger than 10 MB each.",
    replyPartialUpload: "The reply was sent, but some images could not be uploaded.",
    downloadError: "Could not download the attachment.",
    previewError: "Could not open the attachment.",
    preview: "Attachment preview",
    download: "Download",
    close: "Close",
    uploadAvatar: "Upload Ayan's avatar",
    changeAvatar: "Change Ayan's avatar",
    deleteAvatar: "Delete",
    deleteAvatarConfirm: "Delete Ayan's current avatar?",
    avatarFileError: "Use a JPEG or PNG image up to 10 MB for the avatar.",
    avatarActionError: "Could not update Ayan's avatar.",
  },
};

const statusLabels = {
  ru: { NEW: "Новое", IN_PROGRESS: "В работе", WAITING_USER: "Ожидает пользователя", RESOLVED: "Решено", CLOSED: "Закрыто" },
  en: { NEW: "New", IN_PROGRESS: "In progress", WAITING_USER: "Waiting for user", RESOLVED: "Resolved", CLOSED: "Closed" },
};
const categoryLabels = {
  ru: { QUESTION: "Вопрос", BUG: "Ошибка", ACCESS: "Доступ", SIGNATURE: "Подписание", NCALAYER: "NCALayer", OTHER: "Другое" },
  en: { QUESTION: "Question", BUG: "Bug", ACCESS: "Access", SIGNATURE: "Signing", NCALAYER: "NCALayer", OTHER: "Other" },
};
const priorityLabels = {
  ru: { LOW: "Низкий", NORMAL: "Обычный", HIGH: "Высокий", CRITICAL: "Критический" },
  en: { LOW: "Low", NORMAL: "Normal", HIGH: "High", CRITICAL: "Critical" },
};

const store = useStore();
const route = useRoute();
const router = useRouter();
const locale = getLocale();
const text = copies[locale];
const allStatuses: TicketStatus[] = ["NEW", "IN_PROGRESS", "WAITING_USER", "RESOLVED", "CLOSED"];
const categories: TicketCategory[] = ["QUESTION", "BUG", "ACCESS", "SIGNATURE", "NCALAYER", "OTHER"];
const priorities: TicketPriority[] = ["LOW", "NORMAL", "HIGH", "CRITICAL"];
const MAX_REPLY_FILES = 5;
const MAX_REPLY_FILE_SIZE = 10 * 1024 * 1024;
const REPLY_FILE_TYPES = new Set(["image/jpeg", "image/png"]);
const TICKET_GROUP_PAGE_SIZE = 30;
const identity = computed(() => store.getters[AuthGetters.GET_USER_IDENTITY]);
const isManager = computed(() => identity.value?.permissions?.includes("HELPDESK_MANAGE") === true);

const ticketGroups = ref<TicketGroupState[]>([
  {
    key: "active",
    statuses: ["NEW", "IN_PROGRESS", "WAITING_USER"],
    expanded: true,
    items: [],
    page: 0,
    totalElements: 0,
    totalPages: 0,
    loading: false,
    itemsLoaded: false,
    requestId: 0,
  },
  {
    key: "resolved",
    statuses: ["RESOLVED"],
    expanded: false,
    items: [],
    page: 0,
    totalElements: 0,
    totalPages: 0,
    loading: false,
    itemsLoaded: false,
    requestId: 0,
  },
  {
    key: "closed",
    statuses: ["CLOSED"],
    expanded: false,
    items: [],
    page: 0,
    totalElements: 0,
    totalPages: 0,
    loading: false,
    itemsLoaded: false,
    requestId: 0,
  },
]);
const selectedTicket = ref<HelpdeskTicketDetails | null>(null);
const managerStatusOptions = computed<TicketStatus[]>(() => {
  const ticket = selectedTicket.value;
  if (!ticket) return [];

  const allowed = Array.isArray(ticket.allowedStatusTransitions)
    ? ticket.allowedStatusTransitions
    : [];
  return [ticket.status, ...allowed.filter((status) => status !== ticket.status)];
});
const selectedTicketId = ref("");
const loading = ref(false);
const detailsLoading = ref(false);
const saving = ref(false);
const sendingReply = ref(false);
const pageError = ref("");
const reply = ref("");
const replyWaitingForUser = ref(false);
const managerStatus = ref<TicketStatus>("NEW");
const managerPriority = ref<TicketPriority>("NORMAL");
const filters = ref({
  status: "" as TicketStatus | "",
  category: "" as TicketCategory | "",
  priority: "" as TicketPriority | "",
  query: "",
});
const avatarInput = ref<HTMLInputElement | null>(null);
const assistantAvatarUrl = ref("");
const avatarSaving = ref(false);
const attachmentPreviewUrl = ref("");
const attachmentPreviewName = ref("");
const attachmentPreviewLoadingId = ref("");
const replyFileInput = ref<HTMLInputElement | null>(null);
const replyFiles = ref<File[]>([]);
const threadRef = ref<HTMLElement | null>(null);
const unreadRealtimeCount = ref(0);
const mobileDetailOpen = ref(typeof route.query.ticket === "string");
const ticketAttachments = computed(() =>
  (selectedTicket.value?.attachments ?? []).filter((attachment) => !attachment.messageId)
);
const messageAttachmentsById = computed(() => {
  const result = new Map<string, HelpdeskAttachment[]>();
  for (const attachment of selectedTicket.value?.attachments ?? []) {
    if (!attachment.messageId) continue;
    const current = result.get(attachment.messageId) ?? [];
    current.push(attachment);
    result.set(attachment.messageId, current);
  }
  return result;
});
let realtimeRefreshTimer: ReturnType<typeof setTimeout> | null = null;
let realtimeSyncing = false;
let pendingMessageSequence = 0;
const pendingRealtimeEvents = new Map<string, PendingRealtimeUpdate>();

onMounted(async () => {
  window.addEventListener(HELPDESK_REALTIME_EVENT, onRealtimeUpdate);
  window.addEventListener(HELPDESK_REALTIME_CONNECTED_EVENT, onRealtimeConnected);
  window.addEventListener("keydown", onPageKeydown);
  void loadAssistantAvatar();
  await loadTickets();
});

onBeforeUnmount(() => {
  window.removeEventListener(HELPDESK_REALTIME_EVENT, onRealtimeUpdate);
  window.removeEventListener(HELPDESK_REALTIME_CONNECTED_EVENT, onRealtimeConnected);
  window.removeEventListener("keydown", onPageKeydown);
  if (realtimeRefreshTimer) clearTimeout(realtimeRefreshTimer);
  pendingRealtimeEvents.clear();
  closeAttachmentPreview();
  clearAssistantAvatar();
});

watch(
  () => route.query.ticket,
  (value) => {
    if (typeof value === "string" && value !== selectedTicketId.value) {
      mobileDetailOpen.value = true;
      void selectTicket(value);
    }
  }
);

async function loadTickets(refreshDetails = true) {
  loading.value = true;
  pageError.value = "";
  try {
    await Promise.all(
      ticketGroups.value.map((group) => loadTicketGroup(group, !group.expanded))
    );
    const queryTicket = typeof route.query.ticket === "string" ? route.query.ticket : "";
    const firstVisibleTicket = ticketGroups.value
      .filter((group) => group.expanded)
      .flatMap((group) => group.items)[0];
    const target = queryTicket || selectedTicketId.value || firstVisibleTicket?.id;
    if (target) {
      if (refreshDetails || target !== selectedTicketId.value) {
        await selectTicket(target, false);
      }
    } else {
      selectedTicket.value = null;
      selectedTicketId.value = "";
    }
  } catch (error) {
    for (const group of ticketGroups.value) {
      group.items = [];
      group.totalElements = 0;
      group.totalPages = 0;
      group.itemsLoaded = false;
    }
    selectedTicket.value = null;
    selectedTicketId.value = "";
    pageError.value = text.loadError;
  } finally {
    loading.value = false;
  }
}

async function loadTicketGroup(group: TicketGroupState, countOnly: boolean) {
  const requestId = ++group.requestId;
  group.loading = !countOnly;
  try {
    const requestedPage = countOnly ? 0 : group.page;
    const requestedSize = countOnly ? 1 : TICKET_GROUP_PAGE_SIZE;
    let result = await requestTicketGroup(group, requestedPage, requestedSize);
    if (requestId !== group.requestId) return;

    if (
      !countOnly &&
      result.totalPages > 0 &&
      requestedPage >= result.totalPages
    ) {
      group.page = result.totalPages - 1;
      result = await requestTicketGroup(
        group,
        group.page,
        TICKET_GROUP_PAGE_SIZE
      );
      if (requestId !== group.requestId) return;
    }

    group.totalElements = result.totalElements;
    group.totalPages = countOnly
      ? Math.ceil(result.totalElements / TICKET_GROUP_PAGE_SIZE)
      : result.totalPages;
    if (countOnly) {
      group.items = [];
      group.itemsLoaded = false;
    } else {
      group.items = result.items;
      group.itemsLoaded = true;
    }
  } finally {
    if (requestId === group.requestId) group.loading = false;
  }
}

async function requestTicketGroup(
  group: TicketGroupState,
  requestedPage: number,
  requestedSize: number
) {
  const selectedStatus = isManager.value ? filters.value.status : "";
  if (selectedStatus && !group.statuses.includes(selectedStatus)) {
    return {
      items: [] as HelpdeskTicketSummary[],
      page: 0,
      size: requestedSize,
      totalElements: 0,
      totalPages: 0,
    };
  }

  const params = {
    page: requestedPage,
    size: requestedSize,
    statuses: selectedStatus ? [selectedStatus] : group.statuses,
  };
  const managerFilters = {
    category: filters.value.category,
    priority: filters.value.priority,
    query: filters.value.query,
  };
  const response = isManager.value
    ? await HelpdeskDataService.getAll({ ...params, ...managerFilters })
    : await HelpdeskDataService.getMine(params);
  const result = response.data;
  if (
    !result ||
    !Array.isArray(result.items) ||
    typeof result.totalElements !== "number" ||
    typeof result.totalPages !== "number"
  ) {
    throw new Error("Invalid Helpdesk page response");
  }
  return result;
}

async function toggleTicketGroup(key: TicketGroupKey) {
  const group = findTicketGroup(key);
  group.expanded = !group.expanded;
  if (group.expanded && !group.itemsLoaded) {
    pageError.value = "";
    try {
      await loadTicketGroup(group, false);
      if (!selectedTicketId.value && group.items[0]) {
        await selectTicket(group.items[0].id);
      }
    } catch (error) {
      pageError.value = text.loadError;
    }
  }
}

async function changeGroupPage(key: TicketGroupKey, value: number) {
  const group = findTicketGroup(key);
  if (value < 0 || value >= group.totalPages || value === group.page) return;
  group.page = value;
  pageError.value = "";
  try {
    await loadTicketGroup(group, false);
  } catch (error) {
    pageError.value = text.loadError;
  }
}

function findTicketGroup(key: TicketGroupKey) {
  const group = ticketGroups.value.find((item) => item.key === key);
  if (!group) throw new Error(`Unknown ticket group: ${key}`);
  return group;
}

async function selectTicket(ticketId: string, updateRoute = true) {
  if (!ticketId) return;
  const shouldScrollToBottom =
    ticketId !== selectedTicketId.value || isThreadNearBottom();
  if (ticketId !== selectedTicketId.value) {
    closeAttachmentPreview();
    resetReplyDraft();
    unreadRealtimeCount.value = 0;
  }
  if (updateRoute) {
    mobileDetailOpen.value = true;
  }
  detailsLoading.value = true;
  pageError.value = "";
  try {
    const response = await HelpdeskDataService.getTicket(ticketId);
    const ticket = response.data;
    if (
      !ticket ||
      typeof ticket.id !== "string" ||
      !Array.isArray(ticket.messages) ||
      !Array.isArray(ticket.attachments)
    ) {
      throw new Error("Invalid Helpdesk ticket response");
    }

    const currentTicket = selectedTicket.value;
    const isStaleResponse =
      currentTicket?.id === ticket.id &&
      Number(currentTicket.version) > Number(ticket.version);
    if (!isStaleResponse) {
      selectedTicket.value = ticket;
      managerStatus.value = ticket.status;
      managerPriority.value = ticket.priority;
    }
    selectedTicketId.value = ticketId;
    if (updateRoute && route.query.ticket !== ticketId) {
      await router.replace({ query: { ...route.query, ticket: ticketId } });
    }
  } catch (error) {
    pageError.value = text.loadError;
  } finally {
    detailsLoading.value = false;
    if (shouldScrollToBottom) {
      await nextTick();
      scrollThreadToBottom();
    }
  }
}

function showTicketList() {
  mobileDetailOpen.value = false;
}

function isOwnMessage(message: HelpdeskMessage) {
  return (
    message.authorType !== "SYSTEM" &&
    message.authorId != null &&
    message.authorId === identity.value?.id
  );
}

function isThreadNearBottom() {
  const element = threadRef.value;
  if (!element) return true;
  return element.scrollHeight - element.scrollTop - element.clientHeight < 80;
}

function scrollThreadToBottom(smooth = false) {
  const element = threadRef.value;
  if (element) {
    element.scrollTo({
      top: element.scrollHeight,
      behavior: smooth ? "smooth" : "auto",
    });
  }
}

function onThreadScroll() {
  if (unreadRealtimeCount.value && isThreadNearBottom()) {
    unreadRealtimeCount.value = 0;
  }
}

function showLatestMessages() {
  unreadRealtimeCount.value = 0;
  scrollThreadToBottom(true);
}

async function sendReply() {
  if (!selectedTicket.value || !reply.value || sendingReply.value) return;
  const ticketId = selectedTicket.value.id;
  const body = reply.value.slice(0, 4000);
  const files = [...replyFiles.value];
  const waitingForUser = isManager.value && replyWaitingForUser.value;
  const pendingId = `pending-${Date.now()}-${++pendingMessageSequence}`;
  const pendingMessage: HelpdeskMessage = {
    id: pendingId,
    authorId: identity.value?.id ?? null,
    authorName: currentUserDisplayName(),
    authorType: isManager.value ? "ADMIN" : "USER",
    body,
    createdAt: new Date().toISOString(),
    pending: true,
  };

  sendingReply.value = true;
  pageError.value = "";
  mergeSelectedMessage(ticketId, pendingMessage);
  resetReplyDraft();
  applyOptimisticReplyState(ticketId, waitingForUser, pendingMessage.createdAt);
  await nextTick();
  scrollThreadToBottom(true);

  try {
    const response = await HelpdeskDataService.addMessage(
      ticketId,
      body,
      isManager.value ? waitingForUser : undefined
    );
    mergeSelectedMessage(ticketId, response.data, pendingId);
    const uploadResults = await Promise.all(
      files.map((file) =>
        HelpdeskDataService.uploadMessageAttachment(ticketId, response.data.id, file)
          .then((attachmentResponse) => {
            mergeSelectedAttachment(ticketId, attachmentResponse.data);
            return true;
          })
          .catch(() => false)
      )
    );
    const hasUploadFailure = uploadResults.some((uploaded) => !uploaded);
    await nextTick();
    scrollThreadToBottom(true);
    if (hasUploadFailure) {
      pageError.value = text.replyPartialUpload;
    }
  } catch (error) {
    removeSelectedMessage(ticketId, pendingId);
    if (selectedTicketId.value === ticketId) {
      reply.value = body;
      replyFiles.value = files;
      replyWaitingForUser.value = waitingForUser;
    }
    pageError.value = text.actionError;
  } finally {
    sendingReply.value = false;
  }
}

function currentUserDisplayName() {
  const user = identity.value;
  const fullName = [user?.surname, user?.name, user?.middleName]
    .filter(Boolean)
    .join(" ")
    .trim();
  return fullName || user?.login || "";
}

function applyOptimisticReplyState(
  ticketId: string,
  waitingForUser: boolean,
  updatedAt: string
) {
  if (selectedTicket.value?.id !== ticketId) return;
  const nextStatus: TicketStatus = waitingForUser ? "WAITING_USER" : "IN_PROGRESS";
  selectedTicket.value.status = nextStatus;
  selectedTicket.value.updatedAt = updatedAt;
  selectedTicket.value.waitingUserSince = waitingForUser ? updatedAt : null;
  selectedTicket.value.autoCloseAt = null;
  managerStatus.value = nextStatus;
  updateLoadedSummaryFromSelected();
}

function mergeSelectedMessage(
  ticketId: string,
  message: HelpdeskMessage,
  pendingId?: string
) {
  if (!selectedTicket.value || selectedTicket.value.id !== ticketId || !message?.id) {
    return false;
  }
  const messages = selectedTicket.value.messages;
  const existingIndex = messages.findIndex((item) => item.id === message.id);
  const pendingIndex = pendingId
    ? messages.findIndex((item) => item.id === pendingId)
    : -1;

  if (existingIndex >= 0) {
    messages.splice(existingIndex, 1, { ...messages[existingIndex], ...message, pending: false });
    if (pendingIndex >= 0 && pendingIndex !== existingIndex) {
      messages.splice(pendingIndex, 1);
    }
    return false;
  }
  if (pendingIndex >= 0) {
    messages.splice(pendingIndex, 1, { ...message, pending: false });
  } else {
    messages.push({ ...message, pending: false });
  }
  sortMessages(messages);
  return true;
}

function removeSelectedMessage(ticketId: string, messageId: string) {
  if (selectedTicket.value?.id !== ticketId) return;
  const index = selectedTicket.value.messages.findIndex((item) => item.id === messageId);
  if (index >= 0) selectedTicket.value.messages.splice(index, 1);
}

function mergeSelectedAttachment(ticketId: string, attachment: HelpdeskAttachment) {
  if (!selectedTicket.value || selectedTicket.value.id !== ticketId || !attachment?.id) {
    return false;
  }
  const attachments = selectedTicket.value.attachments;
  const existingIndex = attachments.findIndex((item) => item.id === attachment.id);
  if (existingIndex >= 0) {
    attachments.splice(existingIndex, 1, attachment);
    return false;
  }
  attachments.push(attachment);
  attachments.sort((left, right) => compareDates(left.createdAt, right.createdAt));
  return true;
}

function sortMessages(messages: HelpdeskMessage[]) {
  messages.sort((left, right) => {
    const dateDifference = compareDates(left.createdAt, right.createdAt);
    return dateDifference || left.id.localeCompare(right.id);
  });
}

function compareDates(left: string, right: string) {
  const difference = Date.parse(left) - Date.parse(right);
  return Number.isFinite(difference) ? difference : 0;
}

function selectReplyFiles() {
  replyFileInput.value?.click();
}

function onReplyFilesSelected(event: Event) {
  const input = event.target as HTMLInputElement;
  addReplyFiles(Array.from(input.files ?? []));
  input.value = "";
}

function onReplyPaste(event: ClipboardEvent) {
  const images = Array.from(event.clipboardData?.items ?? [])
    .filter((item) => item.kind === "file" && REPLY_FILE_TYPES.has(item.type))
    .map((item, index) => clipboardImageFile(item.getAsFile(), index))
    .filter((file): file is File => file !== null);
  if (!images.length) return;
  event.preventDefault();
  addReplyFiles(images);
}

function clipboardImageFile(file: File | null, index: number): File | null {
  if (!file || !REPLY_FILE_TYPES.has(file.type)) return null;
  const extension = file.type === "image/png" ? "png" : "jpg";
  const timestamp = new Date().toISOString().replace(/[:.]/g, "-");
  return new File([file], `screenshot-${timestamp}-${index + 1}.${extension}`, {
    type: file.type,
    lastModified: Date.now(),
  });
}

function addReplyFiles(files: File[]) {
  let rejected = false;
  const next = [...replyFiles.value];
  for (const file of files) {
    const duplicate = next.some(
      (current) =>
        current.name === file.name &&
        current.size === file.size &&
        current.lastModified === file.lastModified
    );
    if (duplicate) continue;
    if (
      !REPLY_FILE_TYPES.has(file.type) ||
      file.size > MAX_REPLY_FILE_SIZE ||
      next.length >= MAX_REPLY_FILES
    ) {
      rejected = true;
      continue;
    }
    next.push(file);
  }
  replyFiles.value = next;
  if (rejected) {
    pageError.value = text.replyFileError;
  }
}

function removeReplyFile(index: number) {
  replyFiles.value.splice(index, 1);
}

function resetReplyDraft() {
  reply.value = "";
  replyWaitingForUser.value = false;
  replyFiles.value = [];
  if (replyFileInput.value) {
    replyFileInput.value.value = "";
  }
}

function replyFileKey(file: File) {
  return `${file.name}-${file.size}-${file.lastModified}`;
}

async function updateStatus() {
  if (!selectedTicket.value || managerStatus.value === selectedTicket.value.status) return;
  await updateTicket({ status: managerStatus.value });
}

async function updatePriority() {
  if (!selectedTicket.value || managerPriority.value === selectedTicket.value.priority) return;
  await updateTicket({ priority: managerPriority.value });
}

async function updateTicket(payload: { status?: TicketStatus; priority?: TicketPriority }) {
  if (!selectedTicket.value || saving.value) return;
  saving.value = true;
  pageError.value = "";
  try {
    const previousStatus = selectedTicket.value.status;
    const response = await HelpdeskDataService.update(selectedTicket.value.id, payload);
    setSelectedTicket(response.data);
    await refreshTicketGroupsForStatuses([previousStatus, response.data.status]);
  } catch (error) {
    managerStatus.value = selectedTicket.value.status;
    managerPriority.value = selectedTicket.value.priority;
    pageError.value = text.actionError;
  } finally {
    saving.value = false;
  }
}

async function assignToMe() {
  if (!selectedTicket.value || saving.value) return;
  saving.value = true;
  pageError.value = "";
  try {
    const previousStatus = selectedTicket.value.status;
    const response = await HelpdeskDataService.assignToMe(selectedTicket.value.id);
    setSelectedTicket(response.data);
    await refreshTicketGroupsForStatuses([previousStatus, response.data.status]);
  } catch (error) {
    pageError.value = text.actionError;
  } finally {
    saving.value = false;
  }
}

function setSelectedTicket(ticket: HelpdeskTicketDetails) {
  selectedTicket.value = ticket;
  managerStatus.value = ticket.status;
  managerPriority.value = ticket.priority;
}

function messageAttachments(messageId: string): HelpdeskAttachment[] {
  return messageAttachmentsById.value.get(messageId) ?? [];
}

async function downloadAttachment(attachmentId: string, fileName: string) {
  if (!selectedTicket.value) return;
  try {
    const response = await HelpdeskDataService.downloadAttachment(selectedTicket.value.id, attachmentId);
    const blob = requireImageBlob(response.data);
    const url = URL.createObjectURL(blob);
    triggerDownload(url, fileName);
    window.setTimeout(() => URL.revokeObjectURL(url), 1000);
  } catch (error) {
    pageError.value = text.downloadError;
  }
}

async function previewAttachment(attachmentId: string, fileName: string) {
  if (!selectedTicket.value || attachmentPreviewLoadingId.value) return;
  attachmentPreviewLoadingId.value = attachmentId;
  pageError.value = "";
  try {
    const response = await HelpdeskDataService.downloadAttachment(selectedTicket.value.id, attachmentId);
    const blob = requireImageBlob(response.data);
    const url = URL.createObjectURL(blob);
    closeAttachmentPreview();
    attachmentPreviewUrl.value = url;
    attachmentPreviewName.value = fileName;
  } catch (error) {
    pageError.value = text.previewError;
  } finally {
    attachmentPreviewLoadingId.value = "";
  }
}

function closeAttachmentPreview() {
  if (attachmentPreviewUrl.value) URL.revokeObjectURL(attachmentPreviewUrl.value);
  attachmentPreviewUrl.value = "";
  attachmentPreviewName.value = "";
}

function onPageKeydown(event: KeyboardEvent) {
  if (event.key === "Escape" && attachmentPreviewUrl.value) {
    closeAttachmentPreview();
  }
}

function downloadPreview() {
  if (attachmentPreviewUrl.value) {
    triggerDownload(attachmentPreviewUrl.value, attachmentPreviewName.value);
  }
}

function requireImageBlob(value: unknown): Blob {
  if (!(value instanceof Blob) || !["image/jpeg", "image/png"].includes(value.type)) {
    throw new Error("Invalid attachment response");
  }
  return value;
}

function triggerDownload(url: string, fileName: string) {
  const link = document.createElement("a");
  link.href = url;
  link.download = fileName;
  link.rel = "noopener";
  document.body.appendChild(link);
  link.click();
  link.remove();
}

function selectAvatarFile() {
  avatarInput.value?.click();
}

async function onAvatarSelected(event: Event) {
  const input = event.target as HTMLInputElement;
  const file = input.files?.[0];
  input.value = "";
  if (!file) return;
  if (!["image/jpeg", "image/png"].includes(file.type) || file.size > 10 * 1024 * 1024) {
    pageError.value = text.avatarFileError;
    return;
  }

  avatarSaving.value = true;
  pageError.value = "";
  try {
    await HelpdeskDataService.updateAssistantAvatar(file);
    await loadAssistantAvatar();
    window.dispatchEvent(new CustomEvent(ASSISTANT_AVATAR_UPDATED_EVENT));
  } catch (error) {
    pageError.value = text.avatarActionError;
  } finally {
    avatarSaving.value = false;
  }
}

async function deleteAssistantAvatar() {
  if (!window.confirm(text.deleteAvatarConfirm)) return;
  avatarSaving.value = true;
  pageError.value = "";
  try {
    await HelpdeskDataService.deleteAssistantAvatar();
    clearAssistantAvatar();
    window.dispatchEvent(new CustomEvent(ASSISTANT_AVATAR_UPDATED_EVENT));
  } catch (error) {
    pageError.value = text.avatarActionError;
  } finally {
    avatarSaving.value = false;
  }
}

async function loadAssistantAvatar() {
  try {
    const response = await HelpdeskDataService.getAssistantAvatar();
    const avatar = response.data;
    if (!(avatar instanceof Blob) || !avatar.size || !avatar.type.startsWith("image/")) {
      clearAssistantAvatar();
      return;
    }
    const url = URL.createObjectURL(avatar);
    clearAssistantAvatar();
    assistantAvatarUrl.value = url;
  } catch (_) {
    clearAssistantAvatar();
  }
}

function clearAssistantAvatar() {
  if (assistantAvatarUrl.value) URL.revokeObjectURL(assistantAvatarUrl.value);
  assistantAvatarUrl.value = "";
}

function applyFilters() {
  for (const group of ticketGroups.value) {
    group.page = 0;
    group.itemsLoaded = false;
  }
  void loadTickets();
}

function onRealtimeUpdate(event: Event) {
  const detail = (event as CustomEvent<HelpdeskRealtimeEvent>).detail;
  if (!detail?.ticketId || !allStatuses.includes(detail.status)) return;

  const wasNearBottom =
    detail.ticketId === selectedTicketId.value && isThreadNearBottom();
  const applied = applyRealtimeToSelectedTicket(detail);
  const refreshGroups = applyRealtimeToTicketGroups(detail);

  if (applied.messageAdded || applied.attachmentAdded) {
    void finishRealtimeRender(detail, applied, wasNearBottom);
  }
  if (!applied.refreshSelected && !refreshGroups) return;

  queueRealtimeSync(detail, applied.refreshSelected, refreshGroups);
}

function queueRealtimeSync(
  detail: HelpdeskRealtimeEvent,
  refreshSelected: boolean,
  refreshGroups: boolean
) {
  let current = pendingRealtimeEvents.get(detail.ticketId);
  if (!current) {
    current = {
      event: detail,
      statuses: new Set<TicketStatus>(),
      refreshSelected,
      refreshGroups,
    };
    pendingRealtimeEvents.set(detail.ticketId, current);
  } else if (isNewerRealtimeEvent(detail, current.event)) {
    current.event = detail;
  }
  current.refreshSelected = current.refreshSelected || refreshSelected;
  current.refreshGroups = current.refreshGroups || refreshGroups;
  current.statuses.add(detail.status);
  if (detail.previousStatus) current.statuses.add(detail.previousStatus);
  scheduleRealtimeSync();
}

function applyRealtimeToSelectedTicket(
  event: HelpdeskRealtimeEvent
): RealtimeApplyResult {
  const result: RealtimeApplyResult = {
    refreshSelected: false,
    messageAdded: false,
    attachmentAdded: false,
  };
  const ticket = selectedTicket.value;
  if (!ticket || ticket.id !== event.ticketId) return result;

  const currentVersion = Number(ticket.version);
  const eventVersion = Number(event.ticketVersion);
  if (
    !Number.isFinite(eventVersion) ||
    eventVersion <= 0 ||
    !Number.isFinite(currentVersion) ||
    eventVersion > currentVersion + 1
  ) {
    result.refreshSelected = true;
  }

  if (eventExpectsMessage(event.eventType)) {
    if (isRealtimeMessage(event.message)) {
      result.messageAdded = mergeSelectedMessage(event.ticketId, event.message);
    } else {
      result.refreshSelected = true;
    }
  }
  if (event.eventType === "ATTACHMENT_ADDED") {
    if (isRealtimeAttachment(event.attachment)) {
      result.attachmentAdded = mergeSelectedAttachment(
        event.ticketId,
        event.attachment
      );
    } else {
      result.refreshSelected = true;
    }
  }

  if (
    Number.isFinite(eventVersion) &&
    eventVersion > 0 &&
    eventVersion >= currentVersion
  ) {
    const statusChanged = ticket.status !== event.status;
    ticket.status = event.status;
    ticket.priority = event.priority;
    ticket.assigneeId = event.assigneeId;
    ticket.assigneeName = event.assigneeName;
    ticket.updatedAt = event.ticketUpdatedAt || event.occurredAt;
    ticket.waitingUserSince = event.waitingUserSince ?? null;
    ticket.autoCloseAt = event.autoCloseAt ?? null;
    ticket.version = eventVersion;
    managerStatus.value = event.status;
    managerPriority.value = event.priority;
    if (statusChanged) result.refreshSelected = true;
  }
  return result;
}

function eventExpectsMessage(eventType: string) {
  return eventType === "TICKET_CREATED"
    || eventType === "ADMIN_REPLY_ADDED"
    || eventType === "USER_REPLY_ADDED"
    || eventType === "TICKET_WAITING_USER_REMINDER"
    || eventType === "TICKET_AUTO_CLOSED";
}

function isRealtimeMessage(
  message: HelpdeskMessage | null | undefined
): message is HelpdeskMessage {
  return Boolean(
    message?.id &&
      message.createdAt &&
      typeof message.body === "string" &&
      ["USER", "ADMIN", "SYSTEM"].includes(message.authorType)
  );
}

function isRealtimeAttachment(
  attachment: HelpdeskAttachment | null | undefined
): attachment is HelpdeskAttachment {
  return Boolean(
    attachment?.id &&
      attachment.originalName &&
      attachment.mediaType &&
      attachment.createdAt &&
      Number.isFinite(Number(attachment.sizeBytes))
  );
}

async function finishRealtimeRender(
  event: HelpdeskRealtimeEvent,
  applied: RealtimeApplyResult,
  wasNearBottom: boolean
) {
  await nextTick();
  const ownEvent = event.actorId != null && event.actorId === identity.value?.id;
  if (wasNearBottom || ownEvent) {
    unreadRealtimeCount.value = 0;
    scrollThreadToBottom(true);
  } else if (applied.messageAdded || applied.attachmentAdded) {
    unreadRealtimeCount.value += 1;
  }
}

function applyRealtimeToTicketGroups(event: HelpdeskRealtimeEvent) {
  const previousGroup = ticketGroupKeyForStatus(event.previousStatus || event.status);
  const currentGroup = ticketGroupKeyForStatus(event.status);
  const groupChanged = previousGroup !== currentGroup;
  if (
    event.eventType === "TICKET_CREATED" ||
    event.eventType === "TICKET_UPDATED" ||
    groupChanged
  ) {
    return true;
  }

  const group = currentGroup ? findTicketGroup(currentGroup) : null;
  if (!group || !group.itemsLoaded) return false;
  const existingIndex = group.items.findIndex((item) => item.id === event.ticketId);
  const summary = realtimeSummary(event, existingIndex >= 0 ? group.items[existingIndex] : null);
  if (!summary) return true;

  if (!ticketMatchesCurrentFilters(summary)) {
    if (existingIndex >= 0) return true;
    return false;
  }
  if (existingIndex >= 0) {
    group.items.splice(existingIndex, 1, summary);
  } else if (group.page === 0) {
    group.items.push(summary);
  }
  group.items.sort(compareTicketSummaries);
  if (group.page === 0 && group.items.length > TICKET_GROUP_PAGE_SIZE) {
    group.items.length = TICKET_GROUP_PAGE_SIZE;
  }
  return false;
}

function realtimeSummary(
  event: HelpdeskRealtimeEvent,
  existing: HelpdeskTicketSummary | null
): HelpdeskTicketSummary | null {
  const category = event.category || existing?.category;
  const source = event.source || existing?.source;
  const requesterName = event.requesterName || existing?.requesterName;
  const createdAt = event.createdAt || existing?.createdAt;
  const requesterId = event.requesterId ?? existing?.requesterId ?? null;
  if (
    !category ||
    !source ||
    !requesterName ||
    !createdAt
  ) {
    return null;
  }

  return {
    id: event.ticketId,
    ticketNumber: event.ticketNumber,
    subject: event.subject,
    category,
    status: event.status,
    priority: event.priority,
    source,
    requesterId,
    requesterName,
    assigneeId: event.assigneeId ?? existing?.assigneeId ?? null,
    assigneeName: event.assigneeName,
    createdAt,
    updatedAt: event.ticketUpdatedAt || event.occurredAt,
    waitingUserSince: event.waitingUserSince ?? null,
    autoCloseAt: event.autoCloseAt ?? null,
    version: Number(event.ticketVersion),
  };
}

function ticketMatchesCurrentFilters(ticket: HelpdeskTicketSummary) {
  if (!isManager.value) return true;
  if (filters.value.status && ticket.status !== filters.value.status) return false;
  if (filters.value.category && ticket.category !== filters.value.category) return false;
  if (filters.value.priority && ticket.priority !== filters.value.priority) return false;
  const query = filters.value.query.trim().toLowerCase();
  return !query || [ticket.ticketNumber, ticket.subject, ticket.requesterName]
    .some((value) => value.toLowerCase().includes(query));
}

function compareTicketSummaries(
  left: HelpdeskTicketSummary,
  right: HelpdeskTicketSummary
) {
  return compareDates(right.updatedAt, left.updatedAt)
    || right.ticketNumber.localeCompare(left.ticketNumber);
}

function updateLoadedSummaryFromSelected() {
  const ticket = selectedTicket.value;
  if (!ticket) return;
  for (const group of ticketGroups.value) {
    const index = group.items.findIndex((item) => item.id === ticket.id);
    if (index < 0) continue;
    if (ticketGroupKeyForStatus(ticket.status) !== group.key) continue;
    group.items.splice(index, 1, {
      ...group.items[index],
      status: ticket.status,
      priority: ticket.priority,
      assigneeId: ticket.assigneeId,
      assigneeName: ticket.assigneeName,
      updatedAt: ticket.updatedAt,
      waitingUserSince: ticket.waitingUserSince,
      autoCloseAt: ticket.autoCloseAt,
      version: ticket.version,
    });
    group.items.sort(compareTicketSummaries);
  }
}

function onRealtimeConnected() {
  pendingRealtimeEvents.clear();
  if (realtimeRefreshTimer) clearTimeout(realtimeRefreshTimer);
  realtimeRefreshTimer = setTimeout(() => {
    realtimeRefreshTimer = null;
    pendingRealtimeEvents.clear();
    void loadTickets().finally(() => {
      if (pendingRealtimeEvents.size) scheduleRealtimeSync();
    });
  }, 100);
}

function scheduleRealtimeSync() {
  if (realtimeRefreshTimer || realtimeSyncing) return;
  realtimeRefreshTimer = setTimeout(() => {
    realtimeRefreshTimer = null;
    void syncRealtimeEvents();
  }, 150);
}

async function syncRealtimeEvents() {
  if (realtimeSyncing || !pendingRealtimeEvents.size) return;
  realtimeSyncing = true;
  const updates = Array.from(pendingRealtimeEvents.values());
  pendingRealtimeEvents.clear();

  try {
    const selectedEvent = updates
      .filter((update) => update.refreshSelected)
      .map((update) => update.event)
      .filter((event) => event.ticketId === selectedTicketId.value)
      .sort(compareRealtimeEvents)
      .pop();
    const groupUpdates = updates.filter((update) => update.refreshGroups);
    const tasks: Promise<unknown>[] = [];
    if (groupUpdates.length) {
      tasks.push(refreshTicketGroupsForRealtime(groupUpdates));
    }
    if (selectedEvent) {
      tasks.push(selectTicket(selectedEvent.ticketId, false));
    }
    await Promise.all(tasks);
  } catch (error) {
    pageError.value = text.loadError;
  } finally {
    realtimeSyncing = false;
    if (pendingRealtimeEvents.size) scheduleRealtimeSync();
  }
}

async function refreshTicketGroupsForRealtime(
  updates: PendingRealtimeUpdate[]
) {
  const groups = ticketGroups.value.filter((group) =>
    realtimeGroupNeedsRefresh(group, updates)
  );
  await Promise.all(
    groups.map((group) => loadTicketGroup(group, !group.expanded))
  );
}

function realtimeGroupNeedsRefresh(
  group: TicketGroupState,
  updates: PendingRealtimeUpdate[]
) {
  return updates.some((update) => {
    const touchesGroup = Array.from(update.statuses).some(
      (status) => ticketGroupKeyForStatus(status) === group.key
    );
    if (!touchesGroup) return false;
    if (!group.expanded || !group.itemsLoaded) return true;

    if (ticketGroupKeyForStatus(update.event.status) !== group.key) {
      return true;
    }
    const summary = group.items.find(
      (ticket) => ticket.id === update.event.ticketId
    );
    const eventVersion = Number(update.event.ticketVersion);
    return (
      !summary ||
      !Number.isFinite(eventVersion) ||
      eventVersion <= 0 ||
      summary.version < eventVersion
    );
  });
}

async function refreshTicketGroupsForStatuses(
  values: Array<TicketStatus | null | undefined>
) {
  const keys = new Set<TicketGroupKey>();
  for (const value of values) {
    const key = ticketGroupKeyForStatus(value);
    if (key) keys.add(key);
  }
  await Promise.all(
    Array.from(keys).map((key) => {
      const group = findTicketGroup(key);
      return loadTicketGroup(group, !group.expanded);
    })
  );
}

function ticketGroupKeyForStatus(
  status: TicketStatus | null | undefined
): TicketGroupKey | null {
  if (!status) return null;
  if (status === "RESOLVED") return "resolved";
  if (status === "CLOSED") return "closed";
  return "active";
}

function isNewerRealtimeEvent(
  candidate: HelpdeskRealtimeEvent,
  current: HelpdeskRealtimeEvent
) {
  return compareRealtimeEvents(candidate, current) > 0;
}

function compareRealtimeEvents(
  left: HelpdeskRealtimeEvent,
  right: HelpdeskRealtimeEvent
) {
  const leftVersion = Number(left.ticketVersion);
  const rightVersion = Number(right.ticketVersion);
  if (Number.isFinite(leftVersion) && Number.isFinite(rightVersion)) {
    const versionDifference = leftVersion - rightVersion;
    if (versionDifference !== 0) return versionDifference;
  }
  if (Number.isFinite(leftVersion) !== Number.isFinite(rightVersion)) {
    return Number.isFinite(leftVersion) ? 1 : -1;
  }
  const timeDifference = Date.parse(left.occurredAt) - Date.parse(right.occurredAt);
  return Number.isFinite(timeDifference) ? timeDifference : 0;
}

function groupLabel(value: TicketGroupKey) {
  if (value === "active") return text.activeTickets;
  if (value === "resolved") return text.resolvedTickets;
  return text.closedTickets;
}

function newMessagesLabel(count: number) {
  return `${text.newMessages}: ${count}`;
}

function statusLabel(value: TicketStatus) { return statusLabels[locale][value]; }
function statusClass(value: TicketStatus) {
  return value === "RESOLVED"
    ? "tag tag--success flex-shrink-0"
    : `helpdesk-status helpdesk-status--${value.toLowerCase()}`;
}
function categoryLabel(value: TicketCategory) { return categoryLabels[locale][value]; }
function priorityLabel(value: TicketPriority) { return priorityLabels[locale][value]; }
function formatDate(value: string) { return formatDateTime(value); }
function formatBytes(value: number) { return value < 1024 * 1024 ? `${Math.ceil(value / 1024)} KB` : `${(value / 1024 / 1024).toFixed(1)} MB`; }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _createElementVNode("div", null, [
        _createElementVNode("h1", null, _toDisplayString(_unref(text).title), 1),
        _createElementVNode("p", null, _toDisplayString(_unref(isManager) ? _unref(text).managerSubtitle : _unref(text).userSubtitle), 1)
      ]),
      _createElementVNode("div", _hoisted_3, [
        (_unref(isManager))
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                (assistantAvatarUrl.value)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: assistantAvatarUrl.value,
                      alt: ""
                    }, null, 8, _hoisted_6))
                  : (_openBlock(), _createElementBlock("span", _hoisted_7, "AI"))
              ]),
              _createElementVNode("input", {
                ref: (_value, _refs) => {
                  _refs['avatarInput'] = _value
                  avatarInput.value = _value
                },
                class: "helpdesk-visually-hidden",
                type: "file",
                accept: "image/jpeg,image/png",
                disabled: avatarSaving.value,
                onChange: onAvatarSelected
              }, null, 40, _hoisted_8),
              _createElementVNode("button", {
                type: "button",
                disabled: avatarSaving.value,
                onClick: selectAvatarFile
              }, _toDisplayString(assistantAvatarUrl.value ? _unref(text).changeAvatar : _unref(text).uploadAvatar), 9, _hoisted_9),
              (assistantAvatarUrl.value)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    class: "helpdesk-button-secondary",
                    disabled: avatarSaving.value,
                    onClick: deleteAssistantAvatar
                  }, _toDisplayString(_unref(text).deleteAvatar), 9, _hoisted_10))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("button", {
          class: "helpdesk-refresh",
          type: "button",
          disabled: loading.value,
          onClick: loadTickets
        }, _toDisplayString(_unref(text).refresh), 9, _hoisted_11)
      ])
    ]),
    (_unref(isManager))
      ? (_openBlock(), _createElementBlock("section", {
          key: 0,
          class: "helpdesk-filters",
          "aria-label": _unref(text).filters
        }, [
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((filters.value.query) = $event)),
            type: "search",
            maxlength: "120",
            placeholder: _unref(text).search,
            onKeydown: _withKeys(applyFilters, ["enter"])
          }, null, 40, _hoisted_13), [
            [
              _vModelText,
              filters.value.query,
              void 0,
              { trim: true }
            ]
          ]),
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((filters.value.status) = $event)),
            onChange: applyFilters
          }, [
            _createElementVNode("option", _hoisted_14, _toDisplayString(_unref(text).allStatuses), 1),
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(allStatuses, (status) => {
              return _createElementVNode("option", {
                key: status,
                value: status
              }, _toDisplayString(statusLabel(status)), 9, _hoisted_15)
            }), 64))
          ], 544), [
            [_vModelSelect, filters.value.status]
          ]),
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((filters.value.category) = $event)),
            onChange: applyFilters
          }, [
            _createElementVNode("option", _hoisted_16, _toDisplayString(_unref(text).allCategories), 1),
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(categories, (category) => {
              return _createElementVNode("option", {
                key: category,
                value: category
              }, _toDisplayString(categoryLabel(category)), 9, _hoisted_17)
            }), 64))
          ], 544), [
            [_vModelSelect, filters.value.category]
          ]),
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((filters.value.priority) = $event)),
            onChange: applyFilters
          }, [
            _createElementVNode("option", _hoisted_18, _toDisplayString(_unref(text).allPriorities), 1),
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(priorities, (priority) => {
              return _createElementVNode("option", {
                key: priority,
                value: priority
              }, _toDisplayString(priorityLabel(priority)), 9, _hoisted_19)
            }), 64))
          ], 544), [
            [_vModelSelect, filters.value.priority]
          ]),
          _createElementVNode("button", {
            type: "button",
            onClick: applyFilters
          }, _toDisplayString(_unref(text).find), 1)
        ], 8, _hoisted_12))
      : _createCommentVNode("", true),
    (pageError.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_20, _toDisplayString(pageError.value), 1))
      : _createCommentVNode("", true),
    _createElementVNode("section", {
      class: _normalizeClass(["helpdesk-workspace", { 'helpdesk-workspace--mobile-detail': mobileDetailOpen.value }])
    }, [
      _createElementVNode("aside", {
        class: "helpdesk-list",
        "aria-label": _unref(text).tickets
      }, [
        _createElementVNode("div", _hoisted_22, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(ticketGroups.value, (group) => {
            return (_openBlock(), _createElementBlock("section", {
              key: group.key,
              class: "helpdesk-ticket-group"
            }, [
              _createElementVNode("button", {
                type: "button",
                class: "helpdesk-ticket-group-toggle",
                "aria-expanded": group.expanded,
                onClick: ($event: any) => (toggleTicketGroup(group.key))
              }, [
                _createElementVNode("span", null, _toDisplayString(groupLabel(group.key)), 1),
                _createElementVNode("span", _hoisted_24, [
                  _createElementVNode("span", _hoisted_25, _toDisplayString(group.totalElements), 1),
                  _createElementVNode("span", {
                    class: _normalizeClass(["helpdesk-ticket-chevron", {
                    'helpdesk-ticket-chevron--expanded': group.expanded,
                  }]),
                    "aria-hidden": "true"
                  }, null, 2)
                ])
              ], 8, _hoisted_23),
              (group.expanded)
                ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                    (group.loading)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_27, _toDisplayString(_unref(text).loading), 1))
                      : (!group.items.length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_28, _toDisplayString(_unref(text).emptyGroup), 1))
                        : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(group.items, (ticket) => {
                            return (_openBlock(), _createElementBlock("button", {
                              key: ticket.id,
                              type: "button",
                              class: _normalizeClass(["helpdesk-ticket", {
                    'helpdesk-ticket--active': selectedTicketId.value === ticket.id,
                  }]),
                              onClick: ($event: any) => (selectTicket(ticket.id))
                            }, [
                              _createElementVNode("span", _hoisted_30, [
                                _createElementVNode("strong", null, _toDisplayString(ticket.ticketNumber), 1),
                                _createElementVNode("time", null, _toDisplayString(formatDate(ticket.updatedAt)), 1)
                              ]),
                              _createElementVNode("span", _hoisted_31, _toDisplayString(ticket.subject), 1),
                              (_unref(isManager))
                                ? (_openBlock(), _createElementBlock("span", _hoisted_32, _toDisplayString(ticket.requesterName), 1))
                                : _createCommentVNode("", true),
                              _createElementVNode("span", _hoisted_33, [
                                _createElementVNode("span", {
                                  class: _normalizeClass(statusClass(ticket.status))
                                }, _toDisplayString(statusLabel(ticket.status)), 3),
                                _createElementVNode("span", null, _toDisplayString(priorityLabel(ticket.priority)), 1)
                              ])
                            ], 10, _hoisted_29))
                          }), 128)),
                    (!group.loading && group.totalPages > 1)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                          _createElementVNode("button", {
                            type: "button",
                            disabled: group.page === 0,
                            onClick: ($event: any) => (changeGroupPage(group.key, group.page - 1))
                          }, _toDisplayString(_unref(text).previous), 9, _hoisted_35),
                          _createElementVNode("span", null, _toDisplayString(group.page + 1) + " / " + _toDisplayString(group.totalPages), 1),
                          _createElementVNode("button", {
                            type: "button",
                            disabled: group.page + 1 >= group.totalPages,
                            onClick: ($event: any) => (changeGroupPage(group.key, group.page + 1))
                          }, _toDisplayString(_unref(text).next), 9, _hoisted_36)
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ])
      ], 8, _hoisted_21),
      _createElementVNode("article", {
        class: "helpdesk-detail",
        "aria-busy": detailsLoading.value
      }, [
        (detailsLoading.value && !selectedTicket.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_38, _toDisplayString(_unref(text).loadingTicket), 1))
          : (!selectedTicket.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_39, _toDisplayString(_unref(text).selectTicket), 1))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                _createElementVNode("div", _hoisted_40, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "helpdesk-mobile-back",
                    onClick: showTicketList
                  }, _toDisplayString(_unref(text).backToTickets), 1),
                  _createElementVNode("header", _hoisted_41, [
                    _createElementVNode("div", null, [
                      _createElementVNode("div", _hoisted_42, _toDisplayString(selectedTicket.value.ticketNumber), 1),
                      _createElementVNode("h2", null, _toDisplayString(selectedTicket.value.subject), 1),
                      _createElementVNode("p", null, _toDisplayString(categoryLabel(selectedTicket.value.category)) + " · " + _toDisplayString(formatDate(selectedTicket.value.createdAt)), 1)
                    ]),
                    _createElementVNode("span", {
                      class: _normalizeClass(statusClass(selectedTicket.value.status))
                    }, _toDisplayString(statusLabel(selectedTicket.value.status)), 3)
                  ]),
                  _createElementVNode("dl", _hoisted_43, [
                    _createElementVNode("div", null, [
                      _createElementVNode("dt", null, _toDisplayString(_unref(text).requester), 1),
                      _createElementVNode("dd", null, _toDisplayString(selectedTicket.value.requesterName), 1)
                    ]),
                    _createElementVNode("div", null, [
                      _createElementVNode("dt", null, _toDisplayString(_unref(text).assignee), 1),
                      _createElementVNode("dd", null, _toDisplayString(selectedTicket.value.assigneeName || _unref(text).notAssigned), 1)
                    ]),
                    _createElementVNode("div", null, [
                      _createElementVNode("dt", null, _toDisplayString(_unref(text).priority), 1),
                      _createElementVNode("dd", null, _toDisplayString(priorityLabel(selectedTicket.value.priority)), 1)
                    ]),
                    (selectedTicket.value.routePath)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                          _createElementVNode("dt", null, _toDisplayString(_unref(text).section), 1),
                          _createElementVNode("dd", null, _toDisplayString(selectedTicket.value.routePath), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (selectedTicket.value.errorCode)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                          _createElementVNode("dt", null, _toDisplayString(_unref(text).errorCode), 1),
                          _createElementVNode("dd", null, _toDisplayString(selectedTicket.value.errorCode), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  (selectedTicket.value.status === 'WAITING_USER' && selectedTicket.value.autoCloseAt)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                        _createElementVNode("strong", null, _toDisplayString(_unref(text).waitingForUserStatus), 1),
                        _createElementVNode("span", null, _toDisplayString(_unref(text).autoCloseAt) + " " + _toDisplayString(formatDate(selectedTicket.value.autoCloseAt)), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_unref(isManager))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                        _createElementVNode("label", null, [
                          _createElementVNode("span", null, _toDisplayString(_unref(text).status), 1),
                          _withDirectives(_createElementVNode("select", {
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((managerStatus).value = $event)),
                            disabled: saving.value || _unref(managerStatusOptions).length <= 1,
                            onChange: updateStatus
                          }, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(managerStatusOptions), (status) => {
                              return (_openBlock(), _createElementBlock("option", {
                                key: status,
                                value: status
                              }, _toDisplayString(statusLabel(status)), 9, _hoisted_49))
                            }), 128))
                          ], 40, _hoisted_48), [
                            [_vModelSelect, managerStatus.value]
                          ])
                        ]),
                        _createElementVNode("label", null, [
                          _createElementVNode("span", null, _toDisplayString(_unref(text).priority), 1),
                          _withDirectives(_createElementVNode("select", {
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((managerPriority).value = $event)),
                            disabled: saving.value,
                            onChange: updatePriority
                          }, [
                            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(priorities, (priority) => {
                              return _createElementVNode("option", {
                                key: priority,
                                value: priority
                              }, _toDisplayString(priorityLabel(priority)), 9, _hoisted_51)
                            }), 64))
                          ], 40, _hoisted_50), [
                            [_vModelSelect, managerPriority.value]
                          ])
                        ]),
                        _createElementVNode("button", {
                          type: "button",
                          disabled: saving.value || selectedTicket.value.assigneeId === _unref(identity)?.id,
                          onClick: assignToMe
                        }, _toDisplayString(_unref(text).assignToMe), 9, _hoisted_52)
                      ]))
                    : _createCommentVNode("", true),
                  (_unref(ticketAttachments).length)
                    ? (_openBlock(), _createElementBlock("details", {
                        key: selectedTicket.value.id,
                        class: "helpdesk-attachments"
                      }, [
                        _createElementVNode("summary", null, _toDisplayString(_unref(text).attachments) + " (" + _toDisplayString(_unref(ticketAttachments).length) + ")", 1),
                        _createElementVNode("div", _hoisted_53, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(ticketAttachments), (attachment) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: attachment.id,
                              class: "helpdesk-attachment-row"
                            }, [
                              _createElementVNode("button", {
                                type: "button",
                                disabled: attachmentPreviewLoadingId.value === attachment.id,
                                onClick: ($event: any) => (previewAttachment(attachment.id, attachment.originalName))
                              }, _toDisplayString(attachment.originalName) + " (" + _toDisplayString(formatBytes(attachment.sizeBytes)) + ") ", 9, _hoisted_54),
                              _createElementVNode("button", {
                                type: "button",
                                class: "helpdesk-attachment-download",
                                onClick: ($event: any) => (downloadAttachment(attachment.id, attachment.originalName))
                              }, _toDisplayString(_unref(text).download), 9, _hoisted_55)
                            ]))
                          }), 128))
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("section", {
                  ref: (_value, _refs) => {
                    _refs['threadRef'] = _value
                    threadRef.value = _value
                  },
                  class: "helpdesk-thread",
                  "aria-label": _unref(text).dialog,
                  onScrollPassive: onThreadScroll
                }, [
                  _createVNode(_TransitionGroup, {
                    name: "helpdesk-message",
                    tag: "div",
                    class: "helpdesk-message-list"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedTicket.value.messages, (message) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: message.id,
                          class: _normalizeClass(["helpdesk-message", {
                  'helpdesk-message--own': isOwnMessage(message),
                  'helpdesk-message--system': message.authorType === 'SYSTEM',
                  'helpdesk-message--pending': message.pending,
                }])
                        }, [
                          _createElementVNode("div", _hoisted_57, [
                            _createElementVNode("strong", null, _toDisplayString(message.authorName), 1),
                            _createElementVNode("time", null, _toDisplayString(formatDate(message.createdAt)), 1)
                          ]),
                          _createElementVNode("p", null, _toDisplayString(message.body), 1),
                          (messageAttachments(message.id).length)
                            ? (_openBlock(), _createBlock(_TransitionGroup, {
                                key: 0,
                                name: "helpdesk-attachment",
                                tag: "div",
                                class: "helpdesk-message-attachments"
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(messageAttachments(message.id), (attachment) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      key: attachment.id,
                                      class: "helpdesk-message-attachment"
                                    }, [
                                      _createElementVNode("button", {
                                        type: "button",
                                        disabled: attachmentPreviewLoadingId.value === attachment.id,
                                        onClick: ($event: any) => (previewAttachment(attachment.id, attachment.originalName))
                                      }, _toDisplayString(attachment.originalName) + " (" + _toDisplayString(formatBytes(attachment.sizeBytes)) + ") ", 9, _hoisted_58),
                                      _createElementVNode("button", {
                                        type: "button",
                                        class: "helpdesk-attachment-download",
                                        onClick: ($event: any) => (downloadAttachment(attachment.id, attachment.originalName))
                                      }, _toDisplayString(_unref(text).download), 9, _hoisted_59)
                                    ]))
                                  }), 128))
                                ]),
                                _: 2
                              }, 1024))
                            : _createCommentVNode("", true)
                        ], 2))
                      }), 128))
                    ]),
                    _: 1
                  }),
                  (unreadRealtimeCount.value)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        type: "button",
                        class: "helpdesk-new-messages",
                        onClick: showLatestMessages
                      }, _toDisplayString(newMessagesLabel(unreadRealtimeCount.value)), 1))
                    : _createCommentVNode("", true)
                ], 40, _hoisted_56),
                _createElementVNode("form", {
                  class: "helpdesk-reply",
                  onSubmit: _withModifiers(sendReply, ["prevent"]),
                  onPaste: onReplyPaste
                }, [
                  _createElementVNode("div", _hoisted_61, [
                    _withDirectives(_createElementVNode("textarea", {
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((reply).value = $event)),
                      maxlength: "4000",
                      rows: "3",
                      placeholder: _unref(text).replyPlaceholder,
                      disabled: sendingReply.value || selectedTicket.value.status === 'CLOSED'
                    }, null, 8, _hoisted_62), [
                      [
                        _vModelText,
                        reply.value,
                        void 0,
                        { trim: true }
                      ]
                    ]),
                    (replyFiles.value.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(replyFiles.value, (file, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: replyFileKey(file)
                            }, [
                              _createElementVNode("span", null, _toDisplayString(file.name) + " (" + _toDisplayString(formatBytes(file.size)) + ")", 1),
                              _createElementVNode("button", {
                                type: "button",
                                disabled: sendingReply.value,
                                onClick: ($event: any) => (removeReplyFile(index))
                              }, _toDisplayString(_unref(text).remove), 9, _hoisted_64)
                            ]))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("small", null, _toDisplayString(_unref(text).replyAttachmentsHint), 1),
                    (_unref(isManager))
                      ? (_openBlock(), _createElementBlock("label", _hoisted_65, [
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((replyWaitingForUser).value = $event)),
                            type: "checkbox",
                            disabled: sendingReply.value || selectedTicket.value.status === 'CLOSED'
                          }, null, 8, _hoisted_66), [
                            [_vModelCheckbox, replyWaitingForUser.value]
                          ]),
                          _createElementVNode("span", null, [
                            _createElementVNode("strong", null, _toDisplayString(_unref(text).waitingForUser), 1),
                            _createElementVNode("small", null, _toDisplayString(_unref(text).waitingForUserHint), 1)
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_67, [
                    _createElementVNode("input", {
                      ref: (_value, _refs) => {
                        _refs['replyFileInput'] = _value
                        replyFileInput.value = _value
                      },
                      class: "helpdesk-visually-hidden",
                      type: "file",
                      accept: "image/jpeg,image/png",
                      multiple: "",
                      disabled: sendingReply.value || selectedTicket.value.status === 'CLOSED',
                      onChange: onReplyFilesSelected
                    }, null, 40, _hoisted_68),
                    _createElementVNode("button", {
                      type: "button",
                      class: "helpdesk-button-secondary",
                      disabled: sendingReply.value || selectedTicket.value.status === 'CLOSED',
                      onClick: selectReplyFiles
                    }, _toDisplayString(_unref(text).addImages), 9, _hoisted_69),
                    _createElementVNode("button", {
                      type: "submit",
                      disabled: sendingReply.value || !reply.value || selectedTicket.value.status === 'CLOSED'
                    }, _toDisplayString(sendingReply.value ? _unref(text).sending : _unref(text).send), 9, _hoisted_70)
                  ])
                ], 40, _hoisted_60)
              ], 64))
      ], 8, _hoisted_37)
    ], 2),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      (attachmentPreviewUrl.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "helpdesk-preview-backdrop",
            onClick: _withModifiers(closeAttachmentPreview, ["self"])
          }, [
            _createElementVNode("section", {
              class: "helpdesk-preview-dialog",
              role: "dialog",
              "aria-modal": "true",
              "aria-label": _unref(text).preview
            }, [
              _createElementVNode("header", null, [
                _createElementVNode("strong", null, _toDisplayString(attachmentPreviewName.value), 1),
                _createElementVNode("button", {
                  type: "button",
                  "aria-label": _unref(text).close,
                  onClick: closeAttachmentPreview
                }, "x", 8, _hoisted_73)
              ]),
              _createElementVNode("div", _hoisted_74, [
                _createElementVNode("img", {
                  src: attachmentPreviewUrl.value,
                  alt: attachmentPreviewName.value
                }, null, 8, _hoisted_75)
              ]),
              _createElementVNode("footer", null, [
                _createElementVNode("button", {
                  type: "button",
                  onClick: downloadPreview
                }, _toDisplayString(_unref(text).download), 1),
                _createElementVNode("button", {
                  type: "button",
                  class: "helpdesk-button-secondary",
                  onClick: closeAttachmentPreview
                }, _toDisplayString(_unref(text).close), 1)
              ])
            ], 8, _hoisted_72)
          ], 8, _hoisted_71))
        : _createCommentVNode("", true)
    ]))
  ]))
}
}

})